import {DataViewInterface} from "../Interfaces/DataViewInterface";
import {AttributeInterface} from "../Interfaces/AttributeInterface";
import {BusinessObjectBaseInterface} from "../Interfaces/BusinessObjectBaseInterface";

export class DataView implements DataViewInterface {
    private _id: number;
    private _viewName: string;
    private _businessObjectClass: BusinessObjectBaseInterface;
    private _columns: { id: number; columnOrder: number; type: string; value: AttributeInterface }[];
    private _isActive: boolean;
    private _isDefault: boolean;

    constructor(id: number, viewName: string, businessObjectClass: BusinessObjectBaseInterface, columns: { id: number; columnOrder: number; type: string; value: AttributeInterface }[], isActive: boolean, isDefault: boolean) {
        this._id = id;
        this._viewName = viewName;
        this._businessObjectClass = businessObjectClass;
        this._columns = columns;
        this._isActive = isActive;
        this._isDefault = isDefault;
    }

    get id(): number {
        return this._id;
    }

    set id(value: number) {
        this._id = value;
    }

    get viewName(): string {
        return this._viewName;
    }

    set viewName(value: string) {
        this._viewName = value;
    }

    get businessObjectClass(): BusinessObjectBaseInterface {
        return this._businessObjectClass;
    }

    set businessObjectClass(value: BusinessObjectBaseInterface) {
        this._businessObjectClass = value;
    }

    get columns(): { id: number; columnOrder: number; type: string; value: AttributeInterface }[] {
        return this._columns;
    }

    set columns(value: { id: number; columnOrder: number; type: string; value: AttributeInterface }[]) {
        this._columns = value;
    }

    get isActive(): boolean {
        return this._isActive;
    }

    set isActive(value: boolean) {
        this._isActive = value;
    }

    get isDefault(): boolean {
        return this._isDefault;
    }

    set isDefault(value: boolean) {
        this._isDefault = value;
    }

    clone(): DataView {
        return new DataView(this.id, this.viewName, this.businessObjectClass, this.columns, this.isActive, this.isDefault);
    }

    equal(dataView: DataView): boolean {
        if (!dataView) {
            return false;
        }
        if (this.viewName !== dataView.viewName) {
            return false
        }
        if (this.isActive !== dataView.isActive) {
            return false
        }
        if (this.isDefault !== dataView.isDefault) {
            return false
        }
        return this.businessObjectClass.id === dataView.businessObjectClass.id;
    }

    isRemovable(): boolean {
        if (this.viewName === "full") {
            return false;
        }
        return this.id !== -1;
    }

    isValid(): { valid: boolean, msg: string } {
        if (this.viewName.trim() === "") {
            return {valid: false, msg: "View name is an empty string."}
        }
        if (this.businessObjectClass.id === -1) {
            return {valid: false, msg: "Invalid business object."}
        }
        return {valid: true, msg: null}
    }

    deleteColumn(id: number): void {
        const index = this.columns.findIndex(item => item.id === id);
        if (index !== -1){
            this.columns.splice(index,1);
        }
    }

    sortColumns = (): void => {
        this.columns = this.columns.sort((a,b) => {
            if (a.columnOrder > b.columnOrder) {
                return 1;
            }
            if (a.columnOrder < b.columnOrder) {
                return -1;
            }
            return 0;
        })
    };

    getColumn = (id: number): any => {
        const index = this.columns.findIndex(item => item.id === id);
        if (index !== -1){
            return this.columns[index];
        }
        return null;
    };

    createColumn = (column: any): void => {
        const newColumn = {id: column.rowObj.id, columnOrder: column.columnOrder, type: column.rowObj.type, isNew: false, value: column.rowObj.attr};
        // @ts-ignore
        let columns = this.columns;
        columns.push(newColumn);
    };

    setBusinessObjectClass(value: BusinessObjectBaseInterface) {
        this._businessObjectClass = value;
    };
}



// WEBPACK FOOTER //
// ./app/components/bo-core/models/DataView.ts